import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { compact, filter } from 'lodash';
import { DealFinderState } from '@model/state';
import { getDealFinderAvailableAirports, getDealFinderState } from '@state/slices/deal-finder/dealFinderSelectors';
import { setAirports } from '@state/slices/deal-finder/dealFinderSlice';
import { getAlgoliaStateAirports, getAlgoliaTourAirportsByType } from '@state/slices/algolia/algoliaSelectors';
import { setAirportsQuery } from '@state/slices/algolia/algoliaSlice';
import { TripTypes } from '@model/common/tours/trip-types';
import { AirportResult } from '@model/search';
import { dispatch } from '@state/store';
import { NO_AIRPORT_CODE } from '@model/iceberg/airports';
import { Airports } from './Airports';

export interface AirportsContainerProps {
  tabsRef: any;
  isError?: boolean;
  isCondensed: boolean;
  onChange?: (airports: Array<string>) => void;
  onClear?: () => void;
  airports?: Array<string>;
  available?: Array<string>;
  isNotGroupResults?: boolean;
  placeholderKey?: string;
  tripType?: TripTypes;
  isVisible?: boolean;
}

export const AirportsContainer = ({
  tabsRef,
  isError = false,
  isCondensed,
  onChange,
  onClear,
  airports,
  available,
  isNotGroupResults,
  placeholderKey,
  tripType,
  isVisible
}: AirportsContainerProps) => {
  const dealFinder: DealFinderState = useSelector(getDealFinderState);
  const algoliaAirports: Array<AirportResult> = useSelector(
    tripType ? getAlgoliaTourAirportsByType(tripType) : getAlgoliaStateAirports
  );
  const availableAirports: Array<string> = useSelector(getDealFinderAvailableAirports);

  useEffect(() => {
    if (isVisible) {
      dispatch(setAirportsQuery({ query: '' }));
    }
  }, [isVisible]);

  const handleOnChange = (payload: Array<string>) => {
    const airports =
      payload.includes(NO_AIRPORT_CODE) && payload.length > 1
        ? filter(payload, (code) => code !== NO_AIRPORT_CODE)
        : payload.slice();

    if (onChange) {
      onChange(airports);
    } else {
      dispatch(setAirports(airports));
    }
  };

  const handleOnInputChange = (payload: string) => {
    if (isVisible !== false) {
      dispatch(setAirportsQuery({ query: payload }));
    }
  };

  return (
    <Airports
      values={airports ? compact(airports) : dealFinder.airports}
      isError={isError}
      onChange={handleOnChange}
      onClear={onClear}
      options={algoliaAirports}
      onInputChange={handleOnInputChange}
      available={available || availableAirports}
      tabsRef={tabsRef}
      isCondensed={isCondensed}
      isNotGroupResults={isNotGroupResults}
      placeholderKey={placeholderKey}
    />
  );
};
